import React from 'react';
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ allowedRoles, children }) => {
    const { user, loading, initialized } = useAuth();
    const location = useLocation();

    // Show loading state while checking authentication
    if (loading || !initialized) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh' 
            }}>
                <LoadingSpinner />
            </div>
        );
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If role check is required and user doesn't have the role
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If authenticated and has required role (if any), render children
    return children;
};

export default ProtectedRoute;